import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import AudioCallContentInfoComponent from './component';
import { TranslateOutlined } from '@udesk/icons';
import { Input, Select, Button, Space, Icon, Dropdown } from 'udesk-ui';
import AudioCallTextInfo from '../audio-call-text-info';
import TicketTextInfo from '../ticket-text-info';
import CommentView from '../CommentView';
import SurveyItem from 'src/components/pages/components/survey-item';
import SettingMenu from 'src/components/common/SettingMenu';
import TicketTypeSelect from 'src/components/common/TicketTypeSelect';
import ClassNames from 'classnames';
import _isEmpty from 'lodash-es/isEmpty';
import { hasFeature } from 'src/util/permit';
import './style.scss';

const noop = {};

const SYS_MESSAGE_TYPES = [
    'transfer_send',
    'survey',
    'form',
    'form_received',
    'info_transfer',
    'customer_close',
    'invitation',
    'lock',
    'start_session',
    'close',
];

const DownloadMenu = ({ exportTxt /* exportWord */ }) => {
    const locales = UdeskLocales['current'];

    return (
        <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#fff' }}>
            {exportTxt && (
                <Button type="text" onClick={exportTxt}>
                    {locales.fix.exportTxt}
                </Button>
            )}
            {/* {exportWord && (
                <Button type='text' onClick={exportWord}>
                    {locales.fix.exportWord}
                </Button>
            )} */}
        </div>
    );
};

const DownloadAstText = ({ downloadAudio, exportTxt, exportWord }) => {
    return (
        <Dropdown
            overlay={
                <DownloadMenu
                    downloadAudio={downloadAudio}
                    exportTxt={exportTxt}
                    exportWord={exportWord}
                />
            }
            placement="bottomCenter"
        >
            <i
                className="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-xiazai"
                style={{ alignSelf: 'center' }}
            ></i>
        </Dropdown>
    );
};
const MessageStatus = React.memo((props) => {
    const { status } = props;
    const { color, name } = Udesk.enums.sendStatus[status] || {};
    return (
        Boolean(status) && (
            <div style={{ alignSelf: 'flex-end', margin: '0 8px', color, fontSize: '12px' }}>
                {name}
            </div>
        )
    );
});

export default class AudioCallContentInfo extends AudioCallContentInfoComponent {
    render() {
        let {
            detail,
            markSemanticVisible,
            inspectDataSource,
            caseBase,
            dialogRemarkList,
            canRemarkEdit,
            id,
            changeDialogRemarkList,
            isWechatQa,
            trainRecords,
        } = this.props;

        let {
            computes,
            audioTextListRef,
            highlightSeqIndex,
            highlightSeqList,
            searchContentList,
            keywords,
            viewCheck,
            heightList,
            markFlag,
            pointChildrenPerson,
            pointChildrenComputer,
            testSetListFlag,
            pointContentList,
            itemId,
            waveAudio,
            type,
            ticketFilterType,
        } = this.privates;

        let { actions, locales } = this;

        const { related } = detail;

        const isTicket = inspectDataSource === Udesk.enums.inspectDataSources.ticket.id;

        const isComment =
            inspectDataSource === Udesk.enums.inspectDataSources.eComment.id ||
            inspectDataSource === Udesk.enums.inspectDataSources.mComment.id;

        const isSurvey = inspectDataSource === Udesk.enums.inspectDataSources.survey.id;

        console.log('audioTextItems', computes.audioTextItems);

        return (
            <div
                className="audio-call-content-info"
                onMouseEnter={actions.audioStop}
                onMouseLeave={actions.audioPlay}
            >
                <React.Fragment>
                    <div className="audio-call-content-search">
                        <div style={{ display: 'flex' }}>
                            {!isTicket ? (
                                <>
                                    {!isComment && !isSurvey ? (
                                        <Select
                                            value={type}
                                            style={{ width: 70 }}
                                            onSelect={actions.selectType}
                                            options={Udesk.enums.applyRolesWithRobot.map(
                                                (item) => ({
                                                    label: item.name,
                                                    value: item.id,
                                                })
                                            )}
                                        />
                                    ) : null}

                                    {!isComment ? (
                                        <Input.Search
                                            value={keywords}
                                            className="audio-call-content-search-input"
                                            onChange={actions.keywordsChanged}
                                            placeholder={locales.labels.pleaseEnter}
                                            onSearch={actions.searchContet}
                                        />
                                    ) : null}

                                    {!isWechatQa && !testSetListFlag && !related && (
                                        <Select
                                            getPopupContainer={(triggerNode) =>
                                                triggerNode.parentElement
                                            }
                                            value={this.privates.fieldsId || 'unnamed'}
                                            onChange={actions.selectChange}
                                            style={{ width: '130px', marginRight: '8px' }}
                                            disabled={testSetListFlag}
                                        >
                                            <Select.Option value={'unnamed'}>
                                                {
                                                    locales.components.pages.caseBaseList.detail
                                                        .choiceCaseBase
                                                }
                                            </Select.Option>
                                            {caseBase &&
                                                !_isEmpty(caseBase) &&
                                                caseBase.map((item) => {
                                                    return (
                                                        <Select.Option
                                                            key={item.id}
                                                            value={item.id}
                                                        >
                                                            {item.name}
                                                        </Select.Option>
                                                    );
                                                })}
                                        </Select>
                                    )}

                                    <If condition={this.privates.fieldsId !== 'unnamed'}>
                                        <Button style={{ width: '64px' }} onClick={actions.save}>
                                            {locales.labels.save}
                                        </Button>
                                    </If>
                                </>
                            ) : null}

                            {isTicket ? (
                                <TicketTypeSelect
                                    style={{ width: 200 }}
                                    mode="multiple"
                                    value={ticketFilterType}
                                    onChange={actions.onTicketFilterTypeChange}
                                    maxTagCount={1}
                                    placeholder={
                                        /* 全部 */ UdeskLocales['current'].components
                                            .audioCallContentInfo.template.all
                                    }
                                />
                            ) : null}
                        </div>

                        <Space>
                            {[2, 4, Udesk.enums.inspectDataSources.taobao.id].includes(
                                detail?.inspectDataSource
                            ) && <DownloadAstText exportTxt={actions.exportTxt} />}

                            {hasFeature('sys:largeAi:qa:translate') ? (
                                <Button
                                    type={this.privates.isOriginText ? 'text' : 'link'}
                                    icon={<TranslateOutlined />}
                                    onClick={() => actions.onToggleTranslation()}
                                />
                            ) : null}

                            <SettingMenu
                                reTranslate={this.props.reTranslate}
                                isRelated={true}
                                placement="bottomCenter"
                            />
                        </Space>
                    </div>

                    <If condition={highlightSeqList.length > 0}>
                        <div className="audio-text-highlight-navigation">
                            <div
                                className="audio-text-highlight-navigation-button button-up"
                                onClick={actions.nextHit.params('up')}
                            >
                                <Icon type="ic-arrow-up-s-line" style={{ height: '12px' }} />
                            </div>
                            <div
                                className="audio-text-highlight-navigation-button button-down"
                                onClick={actions.nextHit.params('down')}
                            >
                                <Icon
                                    type="ic-arrow-down-s-xiajiantou"
                                    style={{ height: '12px' }}
                                />
                            </div>
                            <div className="audio-text-highlight-navigation-text">
                                {highlightSeqIndex}/{highlightSeqList.length}
                            </div>
                            <div
                                className="audio-text-highlight-navigation-close"
                                onClick={actions.closeHit}
                            >
                                <i className="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-quxiao"></i>
                            </div>
                        </div>
                    </If>

                    <If condition={pointContentList > 0}>
                        <div className="audio-text-highlight-navigation">
                            <div
                                className="audio-text-highlight-navigation-button button-up"
                                onClick={actions.nextPointed.params('up')}
                            >
                                <Icon type="ic-arrow-up-s-line" style={{ height: '12px' }} />
                            </div>
                            <div
                                className="audio-text-highlight-navigation-button button-down"
                                onClick={actions.nextPointed.params('down')}
                            >
                                <Icon
                                    type="ic-arrow-down-s-xiajiantou"
                                    style={{ height: '12px' }}
                                />
                            </div>
                            <div className="audio-text-highlight-navigation-text">
                                {highlightSeqIndex}/{pointContentList}
                            </div>
                            <div
                                className="audio-text-highlight-navigation-close"
                                onClick={actions.closeHit}
                            >
                                <i className="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-quxiao"></i>
                            </div>
                        </div>
                    </If>

                    <If condition={searchContentList.length > 0}>
                        <div className="audio-text-highlight-navigation">
                            <div
                                className="audio-text-highlight-navigation-button button-up"
                                onClick={actions.nextSearched.params('up')}
                            >
                                <Icon type="ic-arrow-up-s-line" style={{ height: '12px' }} />
                            </div>
                            <div
                                className="audio-text-highlight-navigation-button button-down"
                                onClick={actions.nextSearched.params('down')}
                            >
                                <Icon
                                    type="ic-arrow-down-s-xiajiantou"
                                    style={{ height: '12px' }}
                                />
                            </div>
                            <div className="audio-text-highlight-navigation-text">
                                {highlightSeqIndex}/{searchContentList.length}
                            </div>
                            <div
                                className="audio-text-highlight-navigation-close"
                                onClick={actions.closeSearched}
                            >
                                <i className="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-quxiao"></i>
                            </div>
                        </div>
                    </If>
                </React.Fragment>

                <div
                    className="audio-call-content-view-info-content"
                    style={isTicket ? { padding: 0, backgroundColor: '#fff' } : undefined}
                    ref={audioTextListRef}
                >
                    {isComment ? (
                        <CommentView
                            inspectDataSource={inspectDataSource}
                            data={detail?.dialogRecords?.dialogSentenceList}
                            isOriginText={this.privates.isOriginText}
                        />
                    ) : (
                        <If
                            condition={
                                computes &&
                                computes.audioTextItems &&
                                computes.audioTextItems.length > 0
                            }
                        >
                            <For each="item" index="index" of={computes.audioTextItems}>
                                <With
                                    type={item.states?.content?.type}
                                    role={item.data.role}
                                    content={
                                        this.privates.isOriginText
                                            ? item.states?.content?.data?.originContent ||
                                              item.states?.content?.data?.content
                                            : item.states?.content?.data?.content
                                    }
                                    isSysMsg={SYS_MESSAGE_TYPES.includes(
                                        item.states?.content?.type
                                    )}
                                >
                                    {isTicket ? (
                                        <TicketTextInfo
                                            item={item}
                                            content={
                                                this.privates.isOriginText
                                                    ? item?.allData?.data?.originContent ||
                                                      item?.allData?.data?.content
                                                    : item?.allData?.data?.content
                                            }
                                            itemKey={item?.data?.id}
                                            isLastItem={
                                                index === computes.audioTextItems.length - 1
                                            }
                                        />
                                    ) : isSurvey ? (
                                        <SurveyItem
                                            idx={index}
                                            isFirst={index === 0}
                                            isLast={index === computes.audioTextItems.length - 1}
                                            isOriginText={this.privates.isOriginText}
                                            {...item.data}
                                        />
                                    ) : (
                                        // ) : type === 'robotline' ? (
                                        //     <ChatDivider
                                        //         className="audio-call-content-view-custom-text-info-view"
                                        //         text={
                                        //             /* 以下是机器人服务消息 */ UdeskLocales['current']
                                        //                 .components.audioCallContentInfo.template
                                        //                 .theFollowingIsTheBotServiceMessage
                                        //         }
                                        //     />
                                        // ) : type === 'agentline' ? (
                                        //     <ChatDivider
                                        //         className="audio-call-content-view-custom-text-info-view"
                                        //         text={
                                        //             /* 以下是人工服务消息 */ UdeskLocales['current']
                                        //                 .components.audioCallContentInfo.template
                                        //                 .theFollowingIsTheHumanServiceMessage
                                        //         }
                                        //     />
                                        <React.Fragment>
                                            <If condition={role === 'customer'}>
                                                <div
                                                    className={ClassNames(
                                                        'audio-call-content-body-list',
                                                        {
                                                            'audio-call-content-view-custom-checked':
                                                                viewCheck === item.data.id ||
                                                                actions.checkedChanged(
                                                                    item.data.id,
                                                                    heightList
                                                                ) ||
                                                                itemId === item.data.id,
                                                        }
                                                    )}
                                                >
                                                    <div
                                                        key={detail.id + item.data.id}
                                                        className="audio-call-content-view-custom"
                                                    >
                                                        <Space>
                                                            <If condition={!isSysMsg}>
                                                                <div
                                                                    className="audio-call-content-view-custom-avatar"
                                                                    title={
                                                                        item.data.nickName
                                                                            ? item.data.nickName
                                                                            : ''
                                                                    }
                                                                >
                                                                    {item.data.avatar ? (
                                                                        <div
                                                                            style={{
                                                                                backgroundImage: `url('${item.data.avatar}')`,
                                                                                backgroundSize:
                                                                                    '100% 100%',
                                                                                height: '100%',
                                                                                width: '100%',
                                                                            }}
                                                                        ></div>
                                                                    ) : (
                                                                        <Icon type="ic-user-ren" />
                                                                    )}
                                                                </div>
                                                            </If>
                                                            <AudioCallTextInfo
                                                                rerenderOptimization={true}
                                                                pointChildrenComputerInfo={
                                                                    pointChildrenComputer &&
                                                                    pointChildrenComputer[
                                                                        item.data.id
                                                                    ]
                                                                }
                                                                markFlag={markFlag}
                                                                pointChildrenPersonInfo={
                                                                    pointChildrenPerson &&
                                                                    pointChildrenPerson[
                                                                        item.data.id
                                                                    ]
                                                                }
                                                                heightList={actions.heightListHit(
                                                                    item.data.id,
                                                                    heightList
                                                                )}
                                                                role={role}
                                                                fieldsList={
                                                                    this.privates.fieldsList
                                                                }
                                                                inputFlag={actions.inputFlag}
                                                                fieldsId={this.props.fieldsId}
                                                                markSemanticVisible={
                                                                    markSemanticVisible
                                                                }
                                                                caseBaselist={actions.caseBaselist}
                                                                inspectDataSource={
                                                                    inspectDataSource
                                                                }
                                                                item={item}
                                                                type={type}
                                                                content={content}
                                                                onTimeRangeChanged={
                                                                    actions.sendCurrentTimeRange
                                                                }
                                                                onMarkSemanticClick={
                                                                    actions.markSemantic
                                                                }
                                                                caseBaseFlag={
                                                                    this.privates.caseBaseFlag
                                                                }
                                                                fieldFlag={this.privates.fieldFlag}
                                                                waveAudio={waveAudio}
                                                                onAudioPause={actions.audioPause}
                                                                allData={item.allData}
                                                                playRudio={actions.playRudio}
                                                                isSysMsg={isSysMsg}
                                                                dialogRemarkList={dialogRemarkList}
                                                                changeDialogRemarkList={
                                                                    changeDialogRemarkList
                                                                }
                                                                trainRecords={trainRecords}
                                                                canRemarkEdit={canRemarkEdit}
                                                                id={id}
                                                                callId={detail.callId}
                                                                isOriginText={
                                                                    this.privates.isOriginText
                                                                }
                                                            />
                                                        </Space>
                                                        {/* {
                                                    !isSysMsg && <MessageStatus status={item.data.sendStatus} />
                                                } */}
                                                        {/* <div className='audio-call-content-drag'>
                                                    {markFlag && (
                                                        <Checkbox
                                                            checked={actions.checkedChanged(item.data.id, heightList)}
                                                            onChange={actions.RadioChange.params(
                                                                item.data.id,
                                                                heightList,
                                                                markFlag
                                                            )}
                                                        />
                                                    )} */}
                                                        {/* {!testSetListFlag && !isSysMsg && (
                                                        <DraggableComponent
                                                            onClickd={actions.audioStop}
                                                            markFlag={markFlag}
                                                            onEnd={actions.audioPlay}
                                                            key={detail.id + item.data.id}
                                                            id={item.data.id}
                                                            viewCheckd={actions.viewCheckd}
                                                        />
                                                    )} */}
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                            </If>
                                            <If
                                                condition={
                                                    role === 'agent' ||
                                                    role === 'robot_agent' ||
                                                    role === 'system'
                                                }
                                            >
                                                <div
                                                    className={ClassNames(
                                                        'audio-call-content-body-list',
                                                        {
                                                            'audio-call-content-view-custom-checked':
                                                                viewCheck === item.data.id ||
                                                                actions.checkedChanged(
                                                                    item.data.id,
                                                                    heightList
                                                                ) ||
                                                                itemId === item.data.id,
                                                        }
                                                    )}
                                                >
                                                    <div
                                                        key={detail.id + item.data.id}
                                                        className="audio-call-content-view-costom"
                                                    >
                                                        {!isSysMsg && (
                                                            <MessageStatus
                                                                status={item.data.sendStatus}
                                                            />
                                                        )}
                                                        <Space>
                                                            <AudioCallTextInfo
                                                                pointChildrenComputerInfo={
                                                                    pointChildrenComputer &&
                                                                    pointChildrenComputer[
                                                                        item.data.id
                                                                    ]
                                                                }
                                                                markFlag={markFlag}
                                                                pointChildrenPersonInfo={
                                                                    pointChildrenPerson &&
                                                                    pointChildrenPerson[
                                                                        item.data.id
                                                                    ]
                                                                }
                                                                heightList={actions.heightListHit(
                                                                    item.data.id,
                                                                    heightList
                                                                )}
                                                                role={role}
                                                                inputFlag={actions.inputFlag}
                                                                fieldsId={this.privates.fieldsId}
                                                                markSemanticVisible={
                                                                    markSemanticVisible
                                                                }
                                                                caseBaselist={actions.caseBaselist}
                                                                fieldsList={
                                                                    this.privates.fieldsList
                                                                }
                                                                inspectDataSource={
                                                                    inspectDataSource
                                                                }
                                                                item={item}
                                                                type={type}
                                                                content={content}
                                                                onTimeRangeChanged={
                                                                    actions.sendCurrentTimeRange
                                                                }
                                                                onMarkSemanticClick={
                                                                    actions.markSemantic
                                                                }
                                                                caseBaseFlag={
                                                                    this.privates.caseBaseFlag
                                                                }
                                                                fieldFlag={this.privates.fieldFlag}
                                                                audioStop={actions.audioStop}
                                                                waveAudio={waveAudio}
                                                                onAudioPause={actions.audioPause}
                                                                allData={
                                                                    item.data?.content
                                                                        ? JSON.parse(
                                                                              item.data.content
                                                                          )
                                                                        : noop
                                                                }
                                                                playRudio={actions.playRudio}
                                                                isSysMsg={isSysMsg}
                                                                dialogRemarkList={dialogRemarkList}
                                                                changeDialogRemarkList={
                                                                    changeDialogRemarkList
                                                                }
                                                                trainRecords={trainRecords}
                                                                canRemarkEdit={canRemarkEdit}
                                                                id={id}
                                                                isOriginText={
                                                                    this.privates.isOriginText
                                                                }
                                                            />
                                                            <If condition={!isSysMsg}>
                                                                <div
                                                                    className="audio-call-content-view-costom-avatar"
                                                                    title={
                                                                        item.data.nickName
                                                                            ? item.data.nickName
                                                                            : ''
                                                                    }
                                                                >
                                                                    {item.data.avatar ? (
                                                                        <div
                                                                            style={{
                                                                                backgroundImage: `url('${item.data.avatar}')`,
                                                                                backgroundSize:
                                                                                    '100% 100%',
                                                                                height: '100%',
                                                                                width: '100%',
                                                                            }}
                                                                        ></div>
                                                                    ) : role === 'robot_agent' ? (
                                                                        <i class="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-jiqiren"></i>
                                                                    ) : role === 'system' ? (
                                                                        <i class="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-ic-computer-diannao"></i>
                                                                    ) : (
                                                                        <i class="udesk-qa-react-web-iconfont icon-udesk-qa-react-web-ic-customer-service-kefu"></i>
                                                                    )}
                                                                </div>
                                                            </If>
                                                        </Space>

                                                        {/* <div className='audio-call-content-drag'>
                                                    {markFlag && (
                                                        <Checkbox
                                                            checked={actions.checkedChanged(item.data.id, heightList)}
                                                            onChange={actions.RadioChange.params(
                                                                item.data.id,
                                                                heightList,
                                                                markFlag
                                                            )}
                                                        />
                                                    )} */}
                                                        {/* {!testSetListFlag && !isSysMsg && (
                                                        <DraggableComponent
                                                            onClickd={actions.audioStop}
                                                            markFlag={markFlag}
                                                            onEnd={actions.audioPlay}
                                                            key={detail.id + item.data.id}
                                                            id={item.data.id}
                                                            viewCheckd={actions.viewCheckd}
                                                        />
                                                    )} */}
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                            </If>
                                        </React.Fragment>
                                    )}
                                </With>
                            </For>
                        </If>
                    )}
                </div>

                {this.privates.downUrl && (
                    <iframe
                        src={this.privates.downUrl}
                        className="demo-inspection-iframe"
                        title="url"
                    ></iframe>
                )}
            </div>
        );
    }
}
